module.exports = __webpack_public_path__ + "static/media/logo.fe96f9b8.png";